import { render, staticRenderFns } from "./AnamnesisTable.vue?vue&type=template&id=2228a274"
import script from "./AnamnesisTable.vue?vue&type=script&lang=js"
export * from "./AnamnesisTable.vue?vue&type=script&lang=js"
import style0 from "./AnamnesisTable.vue?vue&type=style&index=0&id=2228a274&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports